import React from 'react'
import { css } from '@emotion/core'

import Image from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'

import { rhythm } from '../utils/typography'
import { Fonts } from '../utils/layoutUtils'

function MagicBox({ imgSrc, imgAlt, type, children }) {
  let image;

  if (!!imgSrc && !!imgAlt) {
    image = <StaticQuery
                query={graphql`
                  query {
                    images: allFile {
                      edges {
                        node {
                          relativePath
                          name
                          childImageSharp {
                            fixed(width: 200, height: 200, quality: 90) {
                              ...GatsbyImageSharpFixed
                            }
                          }
                        }
                      }
                    }
                  }
                `}

                render={data => {
                  const image = data.images.edges.find(n => {
                    return n.node.relativePath.includes(imgSrc);
                  });

                  if (!image) {
                    return null;
                  }

                  return <Image alt={imgAlt} fixed={image.node.childImageSharp.fixed} />;
                }}
              />;
  }

  let emoji = `😅`;
  let title = `off-topic`;
  let linkColor = `#ff7f76`;
  let backgroundColor = `#2b3d4f`;
  let foregroundColor = `#ffffff`;

  if (!!type) {
    switch(type) {
      case "warning":
      case "caution":
        backgroundColor = `#fdfd96`;
        foregroundColor = `#2b3d4f`;
        emoji = `⚠`;
        break;

      case "error":
      case "on your own responsibility":
        backgroundColor = `#ff7f76`;
        foregroundColor = `#ffffff`;
        linkColor = `#2b3d4f`;
        emoji = `🛑`;
        break;
    }

    title = type;
  }

  return (
    <div
      css={css`
        background-color: ${backgroundColor};
        color: ${foregroundColor};
        padding: 1.2rem 1.7rem 1.7rem 1.7rem;
        border-radius: 4px;
        margin-left: ${`-${rhythm(1 / 4)}`};
        margin-right: ${`-${rhythm(1 / 4)}`};
        margin-bottom: 1.55rem;
        box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.3);
      `}>
      <small
        css={css`
          display: block;
          text-align: center;
          padding-bottom: 1rem;
          font-family: ${Fonts.SANS};
          font-weight: bold;
          text-transform: uppercase;
        `}
      >
        {emoji} <i>{title}</i>
      </small>
      <div
        css={css`
          display: flex;
          flex-direction: row;
          align-content: center;
          align-items: center;
          justify-content: space-evenly;

          @media only screen and (max-width: 600px) {
            flex-direction: column;
          }

          blockquote {
            color: rgba(255, 255, 255, 0.59);
            border-left-color: rgba(255,255,255, 0.59);
            font-size: 1rem;
          }

          a {
            color: ${linkColor};
          }

          small, div {
            padding-left: 1rem;
          }
        `}
      >
        <div>
          {!!image && image}
        </div>
        <div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default MagicBox
